<template>
  <CForm>
    <CCard>
      <CCardBody>
        <fieldset class="fieldset-register-xlsx">
          <CButton style="width: 100px" block color="primary">
            <router-link
              class="router-link"
              :to="{ path: '/pacientes', query: { type: 'a' } }"
              >Cadastrar</router-link
            >
          </CButton>
        </fieldset>
      </CCardBody>
    </CCard>
    <customAlertaModal
      :show-modal="showModal"
      @update:showModal="showModal = $event"
      :message="message"
      :show-back-button="btn_voltar_inModal"
    />
    <alertaSucesso
      :validacoes-sucesso="validacoes.sucesso"
      :message="validacoes.msg"
    />
    <CCard>
      <CCardBody class="body-card">
        <span>{{ numPaciente }} Pacientes</span>
        <CDataTable
          :items="pacientesFiltros"
          :fields="fields"
          :noResultsView="not_found"
          column-filter
          hover
          sorter
          small
          :fixed="fixed"
          :items-per-page="30"
          :activePage="page"
          :dark="dark"
          pagination
          clickableRows
          @row-clicked="perfilPaciente($event)"
        >
          <template #check="{ item, index }">
            <CInputCheckbox
              v-if="typeUser != 2"
              :checked="item.check"
              class="check__box"
              square
              @click="selecionar(item, index)"
              >Marcar</CInputCheckbox
            >
          </template>
          <template #nameprofessional-filter>
            <CSelect
              :value.sync="profissionalSelecionado"
              :options="profissionais"
              @change="filtroProfissional(profissionalSelecionado)"
            />
          </template>
          <template #acao="{ item, index }">
            <td class="py-4">
              <CButton color="primary" variant="outline" square size="sm"
                ><router-link
                  class="router-link-ver"
                  :to="{
                    path: `/pacientes`,
                    name: 'Pacientes',
                    query: { id: item.id, type: 'b' },
                  }"
                  >VER</router-link
                >
              </CButton>
            </td>
            <td class="py-4">
              <CButton
                v-if="typeUser != 2"
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="inativaPaciente(item, index)"
                >EXCLUIR</CButton
              >
            </td>
          </template>
        </CDataTable>
        <CButton
          v-if="pacientesSelecionados.length > 0"
          class="btn-remover-selecionados"
          color="danger"
          variant="outline"
          square
          size="sm"
          @click="excluirSelecionados()"
          >EXCLUIR SELECIONADOS</CButton
        >
      </CCardBody>
    </CCard>
  </CForm>
</template>
<script>
import {
  buscarPacientes,
  excluir,
} from "../../../common/pacientes/pacienteUtils";
import customAlertaModal from "../../../components/customAlertaModal.vue";
import alertaSucesso from "../../../components/alertaSucesso.vue";

export default {
  name: "ListarPacientes",
  components: {
    customAlertaModal,
    alertaSucesso,
  },
  data() {
    return {
      // Propiedades da tabela
      hover: true,
      small: true,
      fixed: true,
      dark: false,
      page: 5,
      not_found: {
        noResults: "Nenhum registro encontrado",
      },
      pacientes: [],
      fields: [
        {
          key: "check",
          label: "",
          sorter: false,
          filter: false,
        },
        { key: "patient", label: "Nome", _style: "min-width:200px" },
        { key: "social_name", label: "Nome social", _style: "min-width:200px" },
        { key: "name", label: "Convenio", _style: "min-width:100px;" },
        {
          key: "nameprofessional",
          label: "Profissional",
          _style: "min-width:100px;",
        },
        { key: "email", label: "E-mail", _style: "min-width:100px;" },
        { key: "phone", label: "Telefone", _style: "min-width:40px;" },
        { key: "city", label: "Cidade", _style: "min-width:40px;" },
        { key: "status", label: "status", _style: "min-width:40px;" },
        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
          id: "",
        },
      ],

      // Alertas importados
      showModal: false,
      message: "",
      btn_voltar_inModal: false,

      validacoes: { sucesso: false, msg: "" },
      pacientesSelecionados: [],
      profissionais: [],
      profissionalSelecionado: "",
      pacientesFiltros: [],
      typeUser: "",
      numPaciente: 0,
    };
  },
  methods: {
    perfilPaciente(item) {
      this.$router.push({
        path: `/pacientes`,
        name: "Pacientes",
        query: { id: item.id, type: "b" },
      });
    },
    listarTodosPacientes() {
      if (this.typeUser == 2) {
        this.$http
          .get(
            `${process.env.VUE_APP_API_BASE_URL}pacientes/profissional/${this.id}`
          )
          .then((res) => res.json())
          .then((res) => {
            this.pacientes = res;
            //filter for name

            this.pacientes.forEach((x) => {
              if (x.nameprofessional == null) {
                x.nameprofessional = "-";
              }
              x.checkProtocol = false;
              x.check = false;
            });

            this.pacientes.sort((a, b) => {
              if (a.patient < b.patient) {
                return -1;
              }
              if (a.patient > b.patient) {
                return 1;
              }
              return 0;
            });
            this.pacientes.forEach((elem) => {
              elem.patient = elem.patient
                .split(" ")
                .map(
                  (nome) =>
                    nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
                )
                .join(" ");

              elem.city = elem.city
                .split(" ")
                .map(
                  (nome) =>
                    nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
                )
                .join(" ");
            });
            this.pacientesFiltros = this.pacientes;

            this.numPaciente = this.pacientesFiltros.length
          });
      } else {
        this.$http
          .get(process.env.VUE_APP_API_BASE_URL + "pacientes")
          .then((res) => res.json())
          .then((res) => {
            this.pacientes = res;
            //filter for name

            this.pacientes.forEach((x) => {
              if (x.nameprofessional == null) {
                x.nameprofessional = "-";
              }
              x.checkProtocol = false;
              x.check = false;
            });

            this.pacientes.sort((a, b) => {
              if (a.patient < b.patient) {
                return -1;
              }
              if (a.patient > b.patient) {
                return 1;
              }
              return 0;
            });
            this.pacientes.forEach((elem) => {
              elem.patient = elem.patient
                .split(" ")
                .map(
                  (nome) =>
                    nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
                )
                .join(" ");

              elem.city = elem.city
                .split(" ")
                .map(
                  (nome) =>
                    nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
                )
                .join(" ");
            });
            this.pacientesFiltros = this.pacientes;

            // this.pacientes = this.pacientes.map(item => ite)
        
            this.numPaciente = this.pacientesFiltros.length;
          });
       
      }
      
    },
    excluirPaciente(item) {
      const id = item.id;

      excluir(id).then((resultado) => {
        if (!resultado.validacoesSucesso) {
          this.mostrarMensagemDeAlerta(resultado.msgModal);
        } else {
          this.mostrarMensagemDeSucesso(resultado.msgModal);

          this.listarTodosPacientes();
        }
      });
    },
    mostrarMensagemDeSucesso(mensagem) {
      this.validacoes.sucesso = true;
      this.validacoes.msg = mensagem;
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        this.validacoes.sucesso = false;
      }, 1500);
    },
    mostrarMensagemDeAlerta(mensagem) {
      this.showModal = true;
      this.message = mensagem;
      this.btn_voltar_inModal = true;
    },
    selecionar(item, index) {
      event.stopPropagation();
      item.check = !item.check;

      if (item.check) {
        this.pacientesSelecionados.push(item.id);
      } else {
        const id = this.pacientesSelecionados.indexOf(item.id);

        this.pacientesSelecionados.splice(id, 1);
      }
    },

    excluirSelecionados() {
      this.pacientesSelecionados.forEach((id) => {
        this.inativaPaciente({ id });
      });
    },
    ListarProfissionais() {
      this.$http
        .get(process.env.VUE_APP_API_BASE_URL + "profissionais-lista")
        .then((res) => res.json())
        .then((payload) => {
          this.profissionais = payload.map((x) => {
            return {
              label: x.name,
              value: x.id,
            };
          });
          this.profissionais.unshift({
            label: "Todos",
            value: null,
          });
        });
    },
    filtroProfissional(item) {
      if (item == null) {
        this.pacientesFiltros = this.pacientes;
      } else {
        this.pacientesFiltros = this.pacientes.filter(
          (x) => x.id_professional == item
        );
      }

      this.numPaciente = this.pacientesFiltros.length
    },
    inativaPaciente(item, index) {
      event.stopPropagation();
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}paciente/inativar`, {
          id: item.id,
        })
        .then((res) => {
          this.pacientesFiltros = [];
          this.listarTodosPacientes();
        });
    },
  },

  mounted() {
    this.id = localStorage.getItem("id");
    this.typeUser = localStorage.getItem("type");
    this.ListarProfissionais();
    this.listarTodosPacientes();
  },
};
</script>
<style scoped>
.btn-remover-selecionados {
  position: absolute;
  top: 30px;
  left: 300px;
}
.body-card {
  position: relative;
}
.check__box {
  padding: 4px;
}
.pb-4,
.py-4 {
  padding: 10px !important;
}
.form-group {
  margin-bottom: 0rem;
}
</style>
